import Logo from "../assets/Logo.png";
import "./Login.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { signin } from "../actions/Auth";
import Input from "./input";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Typography } from "@mui/material";
import { useState } from "react";
import { Paper, Button } from "@mui/material";
import { Helmet } from "react-helmet-async";
import BRB from "../assets/rosoftsavvy.png";

const Login = () => {
  // return <div className="box"  />

  const initialState = {
    email: "",
    password: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleOnSubmit = (e) => {
    e.preventDefault();
    dispatch(signin(formData, navigate));
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleShowPassword = () =>
    setShowPassword((prevShowPassword) => !prevShowPassword);

  return (
    <div className='container'>
      <Helmet>
        <title>Login | Portfolio Manager</title>
      </Helmet>
      <Paper elevation={16} className='screen'>
        <div className='screen__content'>
          <form className='login' onSubmit={handleOnSubmit}>
            <LazyLoadImage
              effect='blur'
              width={70}
              height={"auto"}
              src={Logo}
              alt='Bosome Freho Rural Bank PLC logo'
            />
            <Typography style={{ fontWeight: "bolder", fontSize: "12px" }}>
              BRB eAdvice
            </Typography>
            <Typography
              style={{
                marginTop: "10px",
                fontWeight: "bold",
                fontSize: "12px",
              }}>
              Account Login
            </Typography>
            <div className='login__field'>
              <Input
                autoFocus={true}
                name='email'
                label={"Email Address"}
                handleChange={handleChange}
                type='email'
                placeholder='User name / Email'
              />
            </div>
            <div className='login__field'>
              <Input
                name={"password"}
                label={"Password"}
                handleChange={handleChange}
                type={showPassword ? "text" : "password"}
                handleShowPassword={handleShowPassword}
              />
            </div>
            <Button
              variant='contained'
              style={{
                fontWeight: "bold",
                fontSize: "14px",
              }}
              type='submit'>
              <span className='button__text'>Continue </span>
            </Button>
          </form>
        </div>

        <div className='screen__background'>
          <span className='screen__background__shape screen__background__shape4'></span>
          <span className='screen__background__shape screen__background__shape3'></span>
          <span className='screen__background__shape screen__background__shape2'></span>
          <span className='screen__background__shape screen__background__shape1'></span>
        </div>
      </Paper>
      <em style={{ marginTop: "10px" }}>
        Powered By <img src={BRB} alt='BRB logo' width={30} height={"auto"} />
      </em>
    </div>
  );
};

export default Login;
